import React from 'react'
import SessionDuration from './SessionDuration'
import SessionDurationRange from './SessionDurationRange'
import WeeklySchedule from './WeeklySchedule'
import ValidationAlert from './ValidationAlert'
import OrganizationType from './OrganizationType'
import { useWeeklyStudy } from 'pages/Planning/hooks/useWeeklyStudy'
import './style.css'
import { IWeeklySchedule, TOrganizationType } from 'pages/Planning/types'

interface WeeklyStudyLoadProps {
  onNext: (stepId: string) => void
  isDarkMode?: boolean
  weeklyHours: number
  weeklySchedule: IWeeklySchedule
  sessionDurationRange: { minDuration: number; maxDuration: number }
  organizationType: TOrganizationType
  updateWeeklyHours: (hours: number) => void
  updateDaySelection: (
    dayKey: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday',
    isSelected: boolean
  ) => void
  updateMinDuration: (minutes: number) => void
  updateMaxDuration: (minutes: number) => void
  updateOrganizationType: (type: TOrganizationType) => void
  isStepCompleted: () => boolean
  validationErrors: Array<{ type: 'error' | 'warning'; message: string; details?: string }>
  hasValidationErrors: boolean
}

const WeeklyStudyLoad: React.FC<WeeklyStudyLoadProps> = ({
  onNext,
  isDarkMode = true,
  weeklyHours,
  weeklySchedule,
  sessionDurationRange,
  organizationType,
  updateWeeklyHours,
  updateDaySelection,
  updateMinDuration,
  updateMaxDuration,
  updateOrganizationType,
  isStepCompleted,
  validationErrors,
  hasValidationErrors,
}) => {
  const handleNext = () => {
    if (isStepCompleted() && !hasValidationErrors) {
      onNext('step-4')
    }
  }

  return (
    <div className={`weekly-study-load ${isDarkMode ? 'dark' : 'light'}`}>
      <OrganizationType
        selectedType={organizationType}
        onTypeChange={updateOrganizationType}
        isDarkMode={isDarkMode}
      />

      {organizationType === 'cycle' && (
        <>
          <SessionDuration weeklyHours={weeklyHours} onWeeklyHoursChange={updateWeeklyHours} />

          <SessionDurationRange
            minDuration={sessionDurationRange.minDuration}
            maxDuration={sessionDurationRange.maxDuration}
            onMinDurationChange={updateMinDuration}
            onMaxDurationChange={updateMaxDuration}
            isDarkMode={isDarkMode}
          />
        </>
      )}

      {organizationType === 'schedule' && (
        <>
          <SessionDurationRange
            minDuration={sessionDurationRange.minDuration}
            maxDuration={sessionDurationRange.maxDuration}
            onMinDurationChange={updateMinDuration}
            onMaxDurationChange={updateMaxDuration}
            isDarkMode={isDarkMode}
          />

          <WeeklySchedule
            weeklySchedule={weeklySchedule}
            onDayToggle={updateDaySelection}
            isDarkMode={isDarkMode}
          />
        </>
      )}

      {validationErrors.length > 0 && (
        <ValidationAlert errors={validationErrors} isDarkMode={isDarkMode} />
      )}

      <div className="item-next-button">
        <button
          className="next-button"
          data-tour="wizard-next"
          onClick={handleNext}
          disabled={!isStepCompleted()}
        >
          Próximo
        </button>
      </div>
    </div>
  )
}

export default WeeklyStudyLoad
